import { render, staticRenderFns } from "./TemporaryPricing.vue?vue&type=template&id=316b7d88&lang=pug&"
import script from "./TemporaryPricing.vue?vue&type=script&lang=js&"
export * from "./TemporaryPricing.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryPricing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports